// ProjectDetailsPage.jsx — ✅ Tower checklist badge + ✅ Modal + ✅ Initialize
// ✅ YES/NO → Verify API (checker/supervisor)
// ✅ Maker Submit → done-maker API
// ✅ Role dropdown removed → role is read from localStorage
// ✅ FIXED: init-context now triggers on phase select for initializer
// ✅ FIXED: phase-aware cache updates
// ✅ FIXED: fetchMeta helper moved to component scope
// ✅ FIXED: initializer role detection unified

import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import projectImage from "../Images/Project.png";
import toast from "react-hot-toast";
import axios from "axios";
import { useTheme } from "../ThemeContext";
import { projectInstance } from "../api/axiosInstance";
import {
  getTowerOverview,
  getTowerOverviewPDF,
  getStageByPhaseId,
} from "../api/index";
import { selectDefaultRole, MODULE_NAMES } from "../utils/roleManager";
import { resolveProjectRoles } from "../utils/UserUtils";
const ProjectDetailsPage = () => {
  const { theme } = useTheme();

  const ORANGE = "#ffbe63";
  const BG_OFFWHITE = "#fcfaf7";
  const bgColor = theme === "dark" ? "#191922" : BG_OFFWHITE;
  const cardColor = theme === "dark" ? "#23232c" : "#fff";
  const borderColor = ORANGE;
  const textColor = theme === "dark" ? "#fff" : "#222";

  const CHECKLIST_API_URL =
    "https://konstruct.world/checklists/transfer-getchchklist/";
  const START_CHECKLIST_API_BASE =
    "https://konstruct.world/checklists/start-checklist/";
  const VERIFY_ITEM_API_URL =
    "https://konstruct.world/checklists/Decsion-makeing-forSuer-Inspector/";
  const DONE_MAKER_API_URL = "https://konstruct.world/checklists/done-maker/";
  const INIT_CONTEXT_API_URL =
    "https://konstruct.world/checklists/init-context/";
  const CREATE_LIVE_CHECKLIST_API_URL =
    "https://konstruct.world/checklists/create-live-checklist-from-template/";

  const { id: projectIdFromUrl } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [towerChecklistMeta, setTowerChecklistMeta] = useState({});
  const [towerChecklistDetails, setTowerChecklistDetails] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTower, setActiveTower] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState("");
  const [modalData, setModalData] = useState(null);

  const [startingById, setStartingById] = useState({});
  const [remarkByItemId, setRemarkByItemId] = useState({});
  const [verifyingKey, setVerifyingKey] = useState({});
  const [makerFilesByItemId, setMakerFilesByItemId] = useState({});
  const [makerSubmittingByItemId, setMakerSubmittingByItemId] = useState({});

  const [phaseList, setPhaseList] = useState([]);
  const [selectedPhaseByTower, setSelectedPhaseByTower] = useState({});
  const [projectLevelData, setProjectLevelData] = useState([]);
  const [activeModalTab, setActiveModalTab] = useState("checklists");
  const SELECTED_PROJECT_KEY = "SELECTED_PROJECT";
  const [stageOptions, setStageOptions] = useState([]);
  const [towerReportFilters, setTowerReportFilters] = useState({
    checklistId: "",
    fromDate: "",
    toDate: "",
    categoryId: "",
    stageId: "",
    status: "",
    currentRole: "",
    withPhotos: false,
  });

  const [towerReportLoading, setTowerReportLoading] = useState(false);

  const [towerReportData, setTowerReportData] = useState(null);

  const [towerReportError, setTowerReportError] = useState("");

  const safeJsonParse = (s) => {
    try {
      return JSON.parse(s);
    } catch {
      return null;
    }
  };

  const getStoredSelectedProject = () => {
    try {
      const raw = localStorage.getItem(SELECTED_PROJECT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const storedProject = getStoredSelectedProject();
  const projectFromState = location.state?.project || storedProject;

  const projectId =
    projectFromState?.id || projectFromState?.project_id || projectIdFromUrl;

  const projectNameInitial =
    projectFromState?.name || projectFromState?.project_name || "";

  const projectImg =
    projectFromState?.image || projectFromState?.image_url || projectImage;

  const [projectName, setProjectName] = useState(projectNameInitial);

  const getPhaseStorageKey = (pid, towerId) =>
    `SELECTED_PHASE_${pid}_${towerId}`;

  const getSavedPhaseForTower = (pid, towerId) => {
    try {
      return localStorage.getItem(getPhaseStorageKey(pid, towerId)) || "";
    } catch {
      return "";
    }
  };

  const savePhaseForTower = (pid, towerId, phaseId) => {
    try {
      localStorage.setItem(
        getPhaseStorageKey(pid, towerId),
        String(phaseId || ""),
      );
    } catch {}
  };

  // const normalizeRole = (raw) => {
  //   const s = String(raw || "").trim();
  //   if (!s) return "";

  //   const up = s.toUpperCase();

  //   if (up === "MAKER") return "maker";
  //   if (up === "CHECKER") return "checker";
  //   if (up === "INSPECTOR") return "checker";
  //   if (up === "SUPERVISOR") return "supervisor";

  //   // support both correct and legacy typo spellings
  //   if (
  //     up === "INITIALIZER" ||
  //     up === "INITIALISER" ||
  //     up === "INTIALIZER" ||
  //     up === "INTIALISER"
  //   ) {
  //     return "initializer";
  //   }

  //   const low = s.toLowerCase();
  //   if (["maker", "checker", "supervisor", "initializer"].includes(low)) {
  //     return low;
  //   }

  //   return "";
  // };

  // const getActiveRoleFromStorage = () => {
  //   const r1 = normalizeRole(localStorage.getItem("FLOW_ROLE"));
  //   if (r1) return r1;

  //   const r2 = normalizeRole(localStorage.getItem("ROLE"));
  //   if (r2) return r2;

  //   const userData = safeJsonParse(localStorage.getItem("USER_DATA"));
  //   const r3 = normalizeRole(userData?.roles?.[0]);
  //   if (r3) return r3;

  //   const pr = safeJsonParse(localStorage.getItem("persist:root"));
  //   const userState = safeJsonParse(pr?.user);
  //   const roles =
  //     userState?.user?.roles ||
  //     userState?.roles ||
  //     userState?.user?.user?.roles ||
  //     userState?.user?.user?.roles;

  //   const r4 = normalizeRole(Array.isArray(roles) ? roles[0] : roles);
  //   if (r4) return r4;

  //   return "checker";
  // };

  // const [activeRoleId, setActiveRoleId] = useState(() =>
  //   getActiveRoleFromStorage()
  // );

  // const refreshRoleFromStorage = () => {
  //   setActiveRoleId(getActiveRoleFromStorage());
  // };

  // const isInitializerRole = () => getActiveRoleFromStorage() === "initializer";

  const getProjectRoleStorageKey = (pid) => `ACTIVE_ROLE_${pid}`;

  const normalizeRole = (raw) => {
    const s = String(raw || "").trim();
    if (!s) return "";

    const up = s.toUpperCase();

    if (up === "MAKER") return "maker";
    if (up === "CHECKER") return "checker";
    if (up === "INSPECTOR") return "checker";
    if (up === "SUPERVISOR") return "supervisor";

    if (
      up === "INITIALIZER" ||
      up === "INITIALISER" ||
      up === "INTIALIZER" ||
      up === "INTIALISER"
    ) {
      return "intializer";
    }

    const low = s.toLowerCase();
    if (["maker", "checker", "supervisor", "initializer"].includes(low)) {
      return low;
    }

    return "";
  };

  const getActiveRoleFromStorage = (pid = projectId) => {
    const projectRole = normalizeRole(
      localStorage.getItem(getProjectRoleStorageKey(pid)),
    );
    const flowRole = normalizeRole(localStorage.getItem("FLOW_ROLE"));
    const activeRole = normalizeRole(localStorage.getItem("ACTIVE_ROLE"));
    const currentSaved = projectRole || flowRole || activeRole;

    const userData = safeJsonParse(localStorage.getItem("USER_DATA"));
    let assigned = [];
    if (userData && pid) {
      assigned = resolveProjectRoles(userData, pid);
    }
    if (!assigned.length && userData?.roles) {
      assigned = Array.isArray(userData.roles) ? userData.roles : [userData.roles];
    }

    const resolved = selectDefaultRole({
      assignedRoles: assigned,
      currentRole: currentSaved,
      module: MODULE_NAMES.CHECKLISTS,
      projectId: pid,
    });

    if (resolved) {
      const lower = resolved.toLowerCase();
      return lower === "intializer" ? "intializer" : lower;
    }

    if (currentSaved) return currentSaved;

    return "checker";
  };

  const [activeRoleId, setActiveRoleId] = useState(() =>
    getActiveRoleFromStorage(projectId),
  );

  const refreshRoleFromStorage = (pid = projectId) => {
    setActiveRoleId(getActiveRoleFromStorage(pid));
  };

  const isInitializerRole = () =>
    getActiveRoleFromStorage(projectId) === "intializer";

  useEffect(() => {
    if (!projectId) return;
    refreshRoleFromStorage(projectId);
  }, [projectId]);
  const token = localStorage.getItem("ACCESS_TOKEN");

  const authHeaders = useMemo(() => {
    if (!token) return {};
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }, [token]);

  const authOnlyHeaders = useMemo(() => {
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
  }, [token]);

  const purposeId =
    location.state?.purposeId ||
    localStorage.getItem("PURPOSE_ID") ||
    localStorage.getItem("purpose_id");

  const fmtDateTime = (v) => {
    if (!v) return "-";
    try {
      return new Date(v).toLocaleString("en-IN");
    } catch {
      return String(v);
    }
  };

  const getTowerPhaseCacheKey = (towerId, phaseId) =>
    `${towerId}_${phaseId || "all"}`;

  const getSelectedPhaseIdForTower = (towerId, overridePhaseId = null) =>
    overridePhaseId ??
    selectedPhaseByTower[towerId] ??
    getSavedPhaseForTower(projectId, towerId) ??
    "";

  const getActiveTowerCacheKey = (towerId, overridePhaseId = null) => {
    const phaseId = getSelectedPhaseIdForTower(towerId, overridePhaseId);
    return getTowerPhaseCacheKey(towerId, phaseId);
  };

  useEffect(() => {
    const loadStages = async () => {
      try {
        const phaseId =
          activeTower?.id && getSelectedPhaseIdForTower(activeTower.id);

        if (!phaseId) {
          setStageOptions([]);
          return;
        }

        const res = await getStageByPhaseId(phaseId);

        const stages = Array.isArray(res.data)
          ? res.data
          : res.data?.results || [];

        setStageOptions(stages);
      } catch (e) {
        console.error("Error fetching stages:", e);
        setStageOptions([]);
      }
    };

    if (isModalOpen && activeModalTab === "reports" && activeTower?.id) {
      loadStages();
    }
  }, [activeTower?.id, activeModalTab, isModalOpen, selectedPhaseByTower]);

  const flattenChecklists = (apiData) => {
    const results = Array.isArray(apiData?.results) ? apiData.results : [];
    const flattened = [];

    for (const r of results) {
      // Case 1: direct checklist row
      if (r && r.id != null && Array.isArray(r.items)) {
        flattened.push(r);
        continue;
      }

      // Case 2: grouped response row
      const legacy = Array.isArray(r?.checklists) ? r.checklists : [];
      const available = Array.isArray(r?.available_for_me)
        ? r.available_for_me
        : [];
      const assigned = Array.isArray(r?.assigned_to_me) ? r.assigned_to_me : [];

      for (const c of [...available, ...assigned, ...legacy]) {
        if (c && c.id != null) flattened.push(c);
      }
    }

    return flattened;
  };

  const applyChecklistUpdateIntoTransferResponse = (data, updatedChecklist) => {
    if (!data || !updatedChecklist?.id) return data;

    const next = { ...data };
    if (!Array.isArray(next.results)) return next;

    const patchArr = (arr) =>
      Array.isArray(arr)
        ? arr.map((c) =>
            c?.id === updatedChecklist.id ? { ...c, ...updatedChecklist } : c,
          )
        : arr;

    next.results = next.results.map((group) => {
      if (!group || typeof group !== "object") return group;

      return {
        ...group,
        available_for_me: patchArr(group.available_for_me),
        assigned_to_me: patchArr(group.assigned_to_me),
        checklists: patchArr(group.checklists),
      };
    });

    return next;
  };

  const applyItemUpdateIntoTransferResponse = (data, patch) => {
    if (!data || !patch?.item_id) return data;

    const next = { ...data };
    if (!Array.isArray(next.results)) return next;

    const patchItemsArr = (items) =>
      Array.isArray(items)
        ? items.map((it) =>
            it?.id === patch.item_id
              ? { ...it, status: patch.item_status }
              : it,
          )
        : items;

    const patchChecklist = (cl) => {
      if (!cl || typeof cl !== "object") return cl;

      const newCl = {
        ...cl,
        status: patch.checklist_status ?? cl.status,
      };

      if (Array.isArray(newCl.items)) {
        newCl.items = patchItemsArr(newCl.items);
      }
      return newCl;
    };

    const patchArr = (arr) =>
      Array.isArray(arr) ? arr.map(patchChecklist) : arr;

    next.results = next.results.map((group) => {
      if (!group || typeof group !== "object") return group;
      return {
        ...group,
        available_for_me: patchArr(group.available_for_me),
        assigned_to_me: patchArr(group.assigned_to_me),
        checklists: patchArr(group.checklists),
      };
    });

    return next;
  };

  const applyMakerDoneIntoTransferResponse = (data, payload) => {
    const item = payload?.item;
    if (!data || !item?.id) return data;

    const next = { ...data };
    if (!Array.isArray(next.results)) return next;

    const patchItemsArr = (items) =>
      Array.isArray(items)
        ? items.map((it) =>
            it?.id === item.id ? { ...it, status: item.status } : it,
          )
        : items;

    const patchChecklist = (cl) => {
      if (!cl || typeof cl !== "object") return cl;

      if (cl?.id === item.checklist) {
        const newCl = { ...cl };
        if (Array.isArray(newCl.items))
          newCl.items = patchItemsArr(newCl.items);
        if (payload?.checklist_status) newCl.status = payload.checklist_status;
        return newCl;
      }

      const newCl = { ...cl };
      if (Array.isArray(newCl.items)) newCl.items = patchItemsArr(newCl.items);
      if (payload?.checklist_status) newCl.status = payload.checklist_status;
      return newCl;
    };

    const patchArr = (arr) =>
      Array.isArray(arr) ? arr.map(patchChecklist) : arr;

    next.results = next.results.map((group) => {
      if (!group || typeof group !== "object") return group;
      return {
        ...group,
        available_for_me: patchArr(group.available_for_me),
        assigned_to_me: patchArr(group.assigned_to_me),
        checklists: patchArr(group.checklists),
      };
    });

    return next;
  };

  // const fetchMetaForTower = async (towerId, phaseIdArg = null) => {
  //   try {
  //     const selectedPhaseId = getSelectedPhaseIdForTower(towerId, phaseIdArg);

  //     const res = await axios.get(CHECKLIST_API_URL, {
  //       params: {
  //         project_id: projectId,
  //         tower_id: towerId,
  //         building_id: towerId,
  //         phase_id: selectedPhaseId || undefined,
  //         limit: 1,
  //         offset: 0,
  //       },
  //       headers: authHeaders,
  //     });

  //     const d = res?.data || {};
  //     const count = Number(d?.count || 0);

  //     return {
  //       loading: false,
  //       count,
  //       hasChecklist: count > 0,
  //       error: false,
  //     };
  //   } catch {
  //     return {
  //       loading: false,
  //       count: 0,
  //       hasChecklist: false,
  //       error: true,
  //     };
  //   }
  // };

  const fetchMetaForTower = async (towerId, phaseIdArg = null) => {
    try {
      const selectedPhaseId = getSelectedPhaseIdForTower(towerId, phaseIdArg);
      const activeRole = getActiveRoleFromStorage(projectId);

      const res = await axios.get(CHECKLIST_API_URL, {
        params: {
          project_id: projectId,
          phase_id: selectedPhaseId || undefined,
          tower_id: towerId,
          building_id: towerId,
          role_id: activeRole || undefined,
          limit: 1,
          offset: 0,
        },
        headers: authHeaders,
      });

      const d = res?.data || {};
      const count = Number(d?.count || 0);

      return {
        loading: false,
        count,
        hasChecklist: count > 0,
        error: false,
      };
    } catch {
      return {
        loading: false,
        count: 0,
        hasChecklist: false,
        error: true,
      };
    }
  };

  // const ensureTowerChecklistForInitializer = async (towerId, phaseId) => {
  //   if (!isInitializerRole()) return null;
  //   if (!projectId || !towerId || !token || !phaseId) return null;

  //   const initRes = await axios.get(INIT_CONTEXT_API_URL, {
  //     params: {
  //       project_id: projectId,
  //       building_id: towerId,
  //       tower_id: towerId,
  //       phase_id: phaseId || undefined,
  //     },
  //     headers: authHeaders,
  //   });

  //   const ctx = initRes?.data || {};

  //   await axios.post(
  //     CREATE_LIVE_CHECKLIST_API_URL,
  //     {
  //       project_id: ctx.project_id || projectId,
  //       purpose_id: ctx.purpose_id,
  //       phase_id: ctx.phase_id,
  //       stage_id: ctx.stage_id,
  //       category: ctx.category,
  //       building_id: ctx.building_id || towerId,
  //       tower_id: ctx.tower_id || towerId,
  //       question_target_type: ctx.question_target_type,
  //       applicable_scope: ctx.applicable_scope,
  //       level_id: ctx.level_id || null,
  //       flat_id: ctx.flat_id || null,
  //       room_id: ctx.room_id || null,
  //       zone_id: ctx.zone_id || null,
  //     },
  //     { headers: authHeaders }
  //   );

  //   return ctx;
  // };

  const ensureTowerChecklistForInitializer = async (towerId, phaseId) => {
    if (!isInitializerRole()) return null;
    if (!projectId || !towerId || !token || !phaseId) return null;

    const initRes = await axios.get(INIT_CONTEXT_API_URL, {
      params: {
        project_id: projectId,
        building_id: towerId,
        tower_id: towerId,
        phase_id: phaseId || undefined,
      },
      headers: authHeaders,
    });

    const ctx = initRes?.data || {};

    await axios.post(
      CREATE_LIVE_CHECKLIST_API_URL,
      {
        project_id: ctx.project_id || projectId,
        purpose_id: ctx.purpose_id,
        phase_id: ctx.phase_id,
        stage_id: ctx.stage_id,

        // ❌ REMOVED CATEGORY

        building_id: ctx.building_id || towerId,
        tower_id: ctx.tower_id || towerId,

        question_target_type: ctx.question_target_type,
        applicable_scope: ctx.applicable_scope,

        level_id: null,
        flat_id: null,
        room_id: null,
        zone_id: null,
      },
      { headers: authHeaders },
    );

    return ctx;
  };

  const openChecklistModal = async (towerObj) => {
    if (!towerObj?.id) return;

    if (!token) {
      toast.error("Token missing. Please login again.");
      return;
    }

    refreshRoleFromStorage();

    const selectedPhaseId = getSelectedPhaseIdForTower(towerObj.id);
    const cacheKey = getActiveTowerCacheKey(towerObj.id);

    setIsModalOpen(true);
    setActiveTower(towerObj);
    setModalError("");

    const cached = towerChecklistDetails[cacheKey];
    if (cached?.raw && !isInitializerRole()) {
      setModalData(cached.raw);
      return;
    }

    setModalLoading(true);
    const activeRole = getActiveRoleFromStorage(projectId);
    try {
      const res = await axios.get(CHECKLIST_API_URL, {
        params: {
          project_id: projectId,
          phase_id: selectedPhaseId || undefined,
          tower_id: towerObj.id,
          building_id: towerObj.id,
          role_id: activeRole || undefined,
          limit: 50,
          offset: 0,
        },
        headers: authHeaders,
      });

      const data = res?.data || {};
      const flattened = flattenChecklists(data);

      setTowerChecklistDetails((prev) => ({
        ...prev,
        [cacheKey]: {
          fetchedAt: Date.now(),
          raw: data,
          flattenedChecklists: flattened,
          stage_history: data?.stage_history || [],
        },
      }));

      setModalData(data);
    } catch (e) {
      const msg =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        "Could not load checklist details.";
      setModalError(msg);
    } finally {
      setModalLoading(false);
    }
  };

  // const handleTowerPhaseChange = async (towerId, phaseId) => {
  //   setSelectedPhaseByTower((prev) => ({
  //     ...prev,
  //     [towerId]: phaseId,
  //   }));

  //   savePhaseForTower(projectId, towerId, phaseId);

  //   try {
  //     if (isInitializerRole() && phaseId) {
  //       console.log("INIT CONTEXT TRIGGERED FROM PHASE SELECT", {
  //         projectId,
  //         towerId,
  //         phaseId,
  //       });

  //       await ensureTowerChecklistForInitializer(towerId, phaseId);
  //     }

  //     // const meta = await fetchMetaForTower(towerId, phaseId);
  //     // setTowerChecklistMeta((prev) => ({
  //     //   ...prev,
  //     //   [towerId]: meta,
  //     // }));

  //     const cacheKey = getTowerPhaseCacheKey(towerId, phaseId);
  //     setTowerChecklistDetails((prev) => {
  //       const next = { ...prev };
  //       delete next[cacheKey];
  //       return next;
  //     });
  //   } catch (e) {
  //     console.log("init context / phase change error", e);
  //   }

  //   if (isModalOpen && activeTower?.id === towerId) {
  //     await openChecklistModal({ id: towerId, name: activeTower?.name });
  //   }
  // };
  const handleTowerPhaseChange = async (towerId, phaseId) => {
    setSelectedPhaseByTower((prev) => ({
      ...prev,
      [towerId]: phaseId,
    }));

    savePhaseForTower(projectId, towerId, phaseId);

    try {
      if (isInitializerRole() && phaseId) {
        console.log("INIT CONTEXT TRIGGERED FROM PHASE SELECT", {
          projectId,
          towerId,
          phaseId,
        });

        // ✅ STEP 1: CREATE CHECKLISTS
        await ensureTowerChecklistForInitializer(towerId, phaseId);

        // ✅ STEP 2: FORCE REFRESH META (🔥 IMPORTANT FIX)
        const meta = await fetchMetaForTower(towerId, phaseId);

        setTowerChecklistMeta((prev) => ({
          ...prev,
          [towerId]: meta,
        }));
      }

      // ✅ STEP 3: CLEAR CACHE (already correct)
      const cacheKey = getTowerPhaseCacheKey(towerId, phaseId);
      setTowerChecklistDetails((prev) => {
        const next = { ...prev };
        delete next[cacheKey];
        return next;
      });
    } catch (e) {
      console.log("init context / phase change error", e);
    }

    // ✅ STEP 4: RELOAD MODAL IF OPEN (already correct)
    if (isModalOpen && activeTower?.id === towerId) {
      await openChecklistModal({ id: towerId, name: activeTower?.name });
    }
  };

  const handleImageClick = (towerId) => {
    const phaseId =
      selectedPhaseByTower[towerId] ||
      getSavedPhaseForTower(projectId, towerId) ||
      location.state?.phaseId ||
      localStorage.getItem("PHASE_ID") ||
      localStorage.getItem("phase_id");

    navigate(`/project/${projectId}/tower/${towerId}`, {
      state: {
        projectLevelData,
        projectId,
        towerId,
        purposeId,
        phaseId,
      },
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveTower(null);
    setModalLoading(false);
    setModalError("");
    setModalData(null);
    setStartingById({});
    refreshRoleFromStorage();
    setRemarkByItemId({});
    setVerifyingKey({});
    setMakerFilesByItemId({});
    setMakerSubmittingByItemId({});
  };

  useEffect(() => {
    if (!projectId) {
      navigate("/");
      return;
    }

    const fetchProjectTower = async () => {
      try {
        if (!token) {
          toast.error("Token missing. Please login again.");
          return;
        }

        const response = await projectInstance.get(
          `/buildings/by_project/${projectId}/`,
          { headers: authHeaders },
        );

        if (response.status === 200 && Array.isArray(response.data)) {
          setProjectLevelData(response.data);
        } else {
          setProjectLevelData([]);
          toast.error("Invalid or empty response from server.");
        }
      } catch {
        setProjectLevelData([]);
        toast.error("Something went wrong while fetching project levels.");
      }
    };

    fetchProjectTower();
  }, [projectId, navigate, token]);

  useEffect(() => {
    if (!projectName && projectId) {
      const fetchProjectName = async () => {
        try {
          if (!token) return;

          const response = await projectInstance.get(
            `/projects/${projectId}/`,
            {
              headers: authHeaders,
            },
          );

          if (response.status === 200 && response.data?.name) {
            setProjectName(response.data.name);
          } else {
            setProjectName(`Project ${projectId}`);
          }
        } catch {
          setProjectName(`Project ${projectId}`);
        }
      };

      fetchProjectName();
    }
  }, [projectId, projectName, token, authHeaders]);

  useEffect(() => {
    if (!projectId || !token) return;

    const fetchPhases = async () => {
      try {
        const res = await projectInstance.get(
          `/phases/by-project/${projectId}/`,
          { headers: authHeaders },
        );

        const phases = Array.isArray(res.data) ? res.data : [];
        setPhaseList(phases);

        const initialSelections = {};
        projectLevelData.forEach((tower) => {
          const saved = getSavedPhaseForTower(projectId, tower.id);
          if (saved) {
            initialSelections[tower.id] = saved;
          }
        });

        setSelectedPhaseByTower((prev) => {
          const next = { ...prev, ...initialSelections };
          const same = JSON.stringify(prev) === JSON.stringify(next);
          return same ? prev : next;
        });
      } catch {
        setPhaseList([]);
      }
    };

    fetchPhases();
  }, [projectId, token, projectLevelData, authHeaders]);

  useEffect(() => {
    if (!projectId || !projectLevelData?.length || !token) return;

    let cancelled = false;

    const init = {};
    projectLevelData.forEach((t) => {
      init[t.id] = {
        loading: true,
        count: 0,
        hasChecklist: false,
        error: false,
      };
    });
    setTowerChecklistMeta(init);

    const runWithConcurrency = async (items, limit) => {
      let idx = 0;

      const runners = new Array(Math.min(limit, items.length))
        .fill(0)
        .map(async () => {
          while (idx < items.length && !cancelled) {
            const currentIndex = idx++;
            const tower = items[currentIndex];
            const meta = await fetchMetaForTower(tower.id);
            if (cancelled) return;

            setTowerChecklistMeta((prev) => ({
              ...prev,
              [tower.id]: meta,
            }));
          }
        });

      await Promise.all(runners);
    };

    runWithConcurrency(projectLevelData, 6);

    return () => {
      cancelled = true;
    };
  }, [projectId, projectLevelData, token, authHeaders, selectedPhaseByTower]);

  const startChecklist = async (checklistId) => {
    if (!checklistId) return;
    if (!token) {
      toast.error("Token missing. Please login again.");
      return;
    }

    setStartingById((prev) => ({ ...prev, [checklistId]: true }));

    try {
      const res = await axios.post(
        `${START_CHECKLIST_API_BASE}${checklistId}/`,
        {},
        { headers: authHeaders },
      );

      const payload = res?.data || {};
      const updated = payload?.checklist;

      if (!updated?.id) {
        toast.error("Initialized, but response is missing checklist data.");
        return;
      }

      toast.success("Checklist initialized ✅");

      setModalData((prev) =>
        applyChecklistUpdateIntoTransferResponse(prev, updated),
      );

      if (activeTower?.id) {
        const cacheKey = getActiveTowerCacheKey(activeTower.id);

        setTowerChecklistDetails((prev) => {
          const current = prev[cacheKey]?.raw || modalData;
          const nextRaw = applyChecklistUpdateIntoTransferResponse(
            current,
            updated,
          );

          return {
            ...prev,
            [cacheKey]: {
              fetchedAt: Date.now(),
              raw: nextRaw,
              flattenedChecklists: flattenChecklists(nextRaw),
              stage_history: nextRaw?.stage_history || [],
            },
          };
        });
      }
    } catch (e) {
      const msg =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        "Failed to initialize checklist.";
      toast.error(String(msg));
    } finally {
      setStartingById((prev) => ({ ...prev, [checklistId]: false }));
    }
  };

  const verifyChecklistItem = async ({ checklistItemId, option, item }) => {
    if (!checklistItemId || !option?.id) return;
    if (!token) {
      toast.error("Token missing. Please login again.");
      return;
    }

    if (activeRoleId !== "checker" && activeRoleId !== "supervisor") {
      toast.error("You are not allowed to verify in this role.");
      return;
    }

    // const choice = String(option?.choice || "").toUpperCase();
    // if (choice !== "P" && choice !== "N") {
    //   toast.error("This option is not a YES/NO action.");
    //   return;
    // }

    const key = `${checklistItemId}:${option.id}:${activeRoleId}`;
    if (verifyingKey[key]) return;

    const itemStatus = String(item?.status || "").toLowerCase();
    if (itemStatus === "completed") {
      toast.success("Already completed ✅");
      return;
    }

    setVerifyingKey((p) => ({ ...p, [key]: true }));

    try {
      const remark = (remarkByItemId[checklistItemId] || "").trim();

      const body = {
        checklist_item_id: checklistItemId,
        role: activeRoleId,
        option_id: option.id,
      };

      if (activeRoleId === "checker") body.check_remark = remark;
      else if (activeRoleId === "supervisor") body.supervisor_remarks = remark;

      const res = await axios.patch(VERIFY_ITEM_API_URL, body, {
        headers: authHeaders,
      });

      const payload = res?.data || {};

      // if (choice === "P") toast.success("Approved ✅");
      // else toast.success("Rejected ✅");
      toast.success("Action submitted ✅");
      setModalData((prev) =>
        applyItemUpdateIntoTransferResponse(prev, payload),
      );

      if (activeTower?.id) {
        const cacheKey = getActiveTowerCacheKey(activeTower.id);

        setTowerChecklistDetails((prev) => {
          const current = prev[cacheKey]?.raw || modalData;
          const nextRaw = applyItemUpdateIntoTransferResponse(current, payload);

          return {
            ...prev,
            [cacheKey]: {
              fetchedAt: Date.now(),
              raw: nextRaw,
              flattenedChecklists: flattenChecklists(nextRaw),
              stage_history: nextRaw?.stage_history || [],
            },
          };
        });
      }
    } catch (e) {
      const msg =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        "Failed to verify item.";
      toast.error(String(msg));
    } finally {
      setVerifyingKey((p) => ({ ...p, [key]: false }));
    }
  };

  // const submitMakerDone = async ({ item }) => {
  //   const checklistItemId = item?.id;
  //   if (!checklistItemId) return;

  //   if (!token) {
  //     toast.error("Token missing. Please login again.");
  //     return;
  //   }

  //   if (activeRoleId !== "maker") {
  //     toast.error("Only MAKER can submit in this screen.");
  //     return;
  //   }

  //   const st = String(item?.status || "").toLowerCase();
  //   const makerAllowed =
  //     st === "pending_for_maker" ||
  //     st === "tetmpory_maker" ||
  //     st === "temporary_maker" ||
  //     st === "rejected_by_checker";

  //   if (!makerAllowed) {
  //     toast.error("This item is not pending for maker.");
  //     return;
  //   }

  //   if (makerSubmittingByItemId[checklistItemId]) return;

  //   const remark = (remarkByItemId[checklistItemId] || "").trim();
  //   const files = makerFilesByItemId[checklistItemId] || [];

  //   if (item?.photo_required && (!files || files.length === 0)) {
  //     toast.error("Photo required. Please attach at least 1 image.");
  //     return;
  //   }

  //   setMakerSubmittingByItemId((p) => ({ ...p, [checklistItemId]: true }));

  //   try {
  //     const fd = new FormData();

  //     fd.append("checklist_item_id", String(checklistItemId));
  //     fd.append("role", "maker");
  //     fd.append("role_id", "maker");
  //     if (remark) {
  //       fd.append("maker_remarks", remark);
  //       fd.append("remark", remark);
  //     }

  //     for (const f of files) {
  //       fd.append("maker_media_multi", f);
  //     }

  //     const res = await axios.post(DONE_MAKER_API_URL, fd, {
  //       headers: {
  //         ...authOnlyHeaders,
  //       },
  //     });

  //     const payload = res?.data || {};
  //     toast.success(payload?.detail || "Submitted to checker ✅");

  //     setModalData((prev) => applyMakerDoneIntoTransferResponse(prev, payload));

  //     if (activeTower?.id) {
  //       const cacheKey = getActiveTowerCacheKey(activeTower.id);

  //       setTowerChecklistDetails((prev) => {
  //         const current = prev[cacheKey]?.raw || modalData;
  //         const nextRaw = applyMakerDoneIntoTransferResponse(current, payload);

  //         return {
  //           ...prev,
  //           [cacheKey]: {
  //             fetchedAt: Date.now(),
  //             raw: nextRaw,
  //             flattenedChecklists: flattenChecklists(nextRaw),
  //             stage_history: nextRaw?.stage_history || [],
  //           },
  //         };
  //       });
  //     }

  //     setRemarkByItemId((p) => ({ ...p, [checklistItemId]: "" }));
  //     setMakerFilesByItemId((p) => ({ ...p, [checklistItemId]: [] }));
  //   } catch (e) {
  //     const msg =
  //       e?.response?.data?.detail ||
  //       e?.response?.data?.error ||
  //       e?.message ||
  //       "Failed to submit item by maker.";
  //     toast.error(String(msg));
  //   } finally {
  //     setMakerSubmittingByItemId((p) => ({ ...p, [checklistItemId]: false }));
  //   }
  // };

  const submitMakerDone = async ({ item }) => {
    const checklistItemId = item?.id;
    if (!checklistItemId) return;

    if (!token) {
      toast.error("Token missing. Please login again.");
      return;
    }

    if (activeRoleId !== "maker") {
      toast.error("Only MAKER can submit in this screen.");
      return;
    }

    const st = String(item?.status || "").toLowerCase();
    const makerAllowed =
      st === "pending_for_maker" ||
      st === "tetmpory_maker" ||
      st === "temporary_maker" ||
      st === "rejected_by_checker";

    if (!makerAllowed) {
      toast.error("This item is not pending for maker.");
      return;
    }

    if (makerSubmittingByItemId[checklistItemId]) return;

    const remark = (remarkByItemId[checklistItemId] || "").trim();
    const files = makerFilesByItemId[checklistItemId] || [];

    if (item?.photo_required && (!files || files.length === 0)) {
      toast.error("Photo required. Please attach at least 1 image.");
      return;
    }

    setMakerSubmittingByItemId((p) => ({ ...p, [checklistItemId]: true }));

    try {
      const fd = new FormData();

      fd.append("checklist_item_id", String(checklistItemId));

      // ✅ send maker role explicitly
      fd.append("role", "maker");
      fd.append("role_id", "maker");

      if (remark) {
        fd.append("maker_remark", remark);
        fd.append("remark", remark);
      }

      for (const f of files) {
        fd.append("maker_media_multi", f);
      }

      const res = await axios.post(DONE_MAKER_API_URL, fd, {
        headers: {
          ...authOnlyHeaders,
        },
      });

      const payload = res?.data || {};
      toast.success(payload?.detail || "Submitted to checker ✅");

      setModalData((prev) => applyMakerDoneIntoTransferResponse(prev, payload));

      if (activeTower?.id) {
        const cacheKey = getActiveTowerCacheKey(activeTower.id);

        setTowerChecklistDetails((prev) => {
          const current = prev[cacheKey]?.raw || modalData;
          const nextRaw = applyMakerDoneIntoTransferResponse(current, payload);

          return {
            ...prev,
            [cacheKey]: {
              fetchedAt: Date.now(),
              raw: nextRaw,
              flattenedChecklists: flattenChecklists(nextRaw),
              stage_history: nextRaw?.stage_history || [],
            },
          };
        });
      }

      setRemarkByItemId((p) => ({ ...p, [checklistItemId]: "" }));
      setMakerFilesByItemId((p) => ({ ...p, [checklistItemId]: [] }));
    } catch (e) {
      const msg =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        "Failed to submit item by maker.";
      toast.error(String(msg));
    } finally {
      setMakerSubmittingByItemId((p) => ({ ...p, [checklistItemId]: false }));
    }
  };

  const fetchTowerReport = async () => {
    if (!activeTower?.id) return;

    try {
      setTowerReportLoading(true);
      setTowerReportError("");

      const params = {
        project_id: projectId,
        // tower_id: activeTower.id,
        // building_id: activeTower.id,
        phase_id: getSelectedPhaseIdForTower(activeTower.id) || undefined,
        // role_id: activeRoleId || undefined,

        stage_id: towerReportFilters.stageId || undefined,

        category_id: towerReportFilters.categoryId || undefined,

        status: towerReportFilters.status || undefined,

        current_role: towerReportFilters.currentRole || undefined,

        from_date: towerReportFilters.fromDate || undefined,

        to_date: towerReportFilters.toDate || undefined,

        with_photos: towerReportFilters.withPhotos ? "true" : undefined,

        checklist_id: towerReportFilters.checklistId || undefined,
      };

      const res = await getTowerOverview(activeTower.id, params);

      setTowerReportData(res?.data || null);
    } catch (e) {
      setTowerReportError(
        e?.response?.data?.detail || "Could not load report.",
      );
    } finally {
      setTowerReportLoading(false);
    }
  };

  useEffect(() => {
    if (isModalOpen && activeModalTab === "reports") {
      fetchTowerReport();
    }
  }, [activeModalTab, activeTower?.id, towerReportFilters]);

  const downloadTowerPdfReport = async () => {
    if (!activeTower?.id) return;

    try {
      const params = {
        project_id: projectId,
        // tower_id: activeTower.id,
        // building_id: activeTower.id,
        phase_id: getSelectedPhaseIdForTower(activeTower.id) || undefined,
        // role_id: activeRoleId || undefined,

        stage_id: towerReportFilters.stageId || undefined,

        category_id: towerReportFilters.categoryId || undefined,

        status: towerReportFilters.status || undefined,

        current_role: towerReportFilters.currentRole || undefined,

        from_date: towerReportFilters.fromDate || undefined,

        to_date: towerReportFilters.toDate || undefined,

        with_photos: towerReportFilters.withPhotos ? "true" : undefined,
      };

      const res = await getTowerOverviewPDF(activeTower.id, params);

      const blob = new Blob([res.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.href = url;

      const disposition = res.headers["content-disposition"] || "";

      const match = disposition.match(/filename="?([^"]+)"?/);

      a.download = match?.[1] || `tower_${activeTower.id}_report.pdf`;

      document.body.appendChild(a);

      a.click();

      a.remove();

      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Failed to download report.");
    }
  };

//  const yesNoLabel = (op) => {
//    const name = String(op?.name || "")
//      .trim()
//      .toUpperCase();

//    // ✅ explicit NA support
//    if (name === "NA" || name === "N/A") {
//      return "NA";
//    }

//    const c = String(op?.choice || "").toUpperCase();

//    if (c === "P") return "YES";
//    if (c === "N") return "NO";

//    return op?.name || "Option";
//  };

  const makerCanSubmitItem = (it) => {
    const st = String(it?.status || "").toLowerCase();
    return (
      st === "pending_for_maker" ||
      st === "tetmpory_maker" ||
      st === "temporary_maker" ||
      st === "rejected_by_checker"
    );
  };

  return (
    <div
      className="flex min-h-screen transition-colors duration-300"
      style={{ backgroundColor: bgColor }}
    >
      <div className="my-8 w-full max-w-6xl mt-8 mx-auto px-4">
        <div
          className="relative pt-8 px-8 pb-10 rounded-2xl transition-all duration-300 hover:shadow-2xl"
          style={{
            backgroundColor: cardColor,
            border: `2px solid ${borderColor}`,
            boxShadow:
              theme === "dark"
                ? `0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 8px 32px rgba(255, 190, 99, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)`
                : `0 25px 50px -12px rgba(0, 0, 0, 0.1), 0 8px 32px rgba(255, 190, 99, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.8)`,
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
          }}
        >
          <div
            className="absolute top-0 left-0 w-32 h-32 rounded-full opacity-10 blur-3xl"
            style={{ backgroundColor: borderColor }}
          />
          <div
            className="absolute bottom-0 right-0 w-24 h-24 rounded-full opacity-10 blur-2xl"
            style={{ backgroundColor: borderColor }}
          />

          <div className="mb-12 relative z-10">
            <div className="text-center">
              <div
                className="w-20 h-1 mx-auto mb-6 rounded-full"
                style={{ backgroundColor: borderColor }}
              />

              <h2
                className="text-5xl font-bold mb-6 tracking-tight relative inline-block"
                style={{
                  color: textColor,
                  textShadow:
                    theme === "dark"
                      ? `0 2px 8px rgba(255, 190, 99, 0.3)`
                      : `0 2px 8px rgba(0, 0, 0, 0.1)`,
                }}
              >
                {projectName || `Project ${projectId}`}
              </h2>
              <p
                className="text-lg font-medium opacity-80"
                style={{ color: textColor }}
              >
                Explore project buildings and levels
              </p>
            </div>
          </div>

          <div className="relative z-10">
            {projectLevelData && projectLevelData.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
                {projectLevelData.map((proj, index) => {
                  const meta = towerChecklistMeta?.[proj.id];
                  const showBadge = true;

                  return (
                    <div
                      key={proj.id}
                      className="group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-105 hover:-translate-y-2 transform-gpu"
                      style={{
                        backgroundColor: cardColor,
                        border: `2px solid ${theme === "dark" ? "#ffffff15" : "#00000010"}`,
                        boxShadow:
                          theme === "dark"
                            ? `0 10px 30px rgba(0, 0, 0, 0.3), 0 4px 16px rgba(255, 190, 99, 0.1)`
                            : `0 10px 30px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(255, 190, 99, 0.15)`,
                        animationDelay: `${index * 0.1}s`,
                      }}
                      onClick={() => handleImageClick(proj.id)}
                    >
                      <div
                        className="p-3 relative z-20"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <select
                          value={selectedPhaseByTower[proj.id] || ""}
                          onChange={(e) =>
                            handleTowerPhaseChange(proj.id, e.target.value)
                          }
                          className="w-full px-3 py-2 rounded-xl text-sm"
                          style={{
                            backgroundColor:
                              theme === "dark" ? "#ffffff10" : "#00000008",
                            color: textColor,
                            border: `1px solid ${borderColor}55`,
                            outline: "none",
                          }}
                        >
                          <option value="">Select Phases</option>
                          {phaseList.map((phase) => (
                            <option key={phase.id} value={phase.id}>
                              {phase.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="relative overflow-hidden">
                        <img
                          src={projectImg}
                          alt={`${proj.name || "Project"} Background`}
                          className="w-full h-72 object-cover transition-all duration-700 group-hover:scale-110 group-hover:brightness-110"
                        />

                        <div
                          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                          style={{
                            background: `linear-gradient(135deg, ${borderColor}20 0%, ${borderColor}40 50%, ${borderColor}20 100%)`,
                          }}
                        />

                        {meta?.loading ? (
                          <div
                            className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold"
                            style={{
                              backgroundColor:
                                theme === "dark" ? "#ffffff12" : "#00000010",
                              color: textColor,
                              border: `1px solid ${borderColor}55`,
                              backdropFilter: "blur(8px)",
                            }}
                          >
                            Loading…
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openChecklistModal(proj);
                            }}
                            className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold"
                            title="Tower Reports & Checklists"
                            style={{
                              backgroundColor: borderColor,
                              color: "#1b1b1b",
                              boxShadow: `0 6px 18px rgba(255, 190, 99, 0.35)`,
                            }}
                          >
                            📋 Reports & Checklists
                            {meta?.count ? ` (${meta.count})` : ""}
                          </button>
                        )}
                      </div>

                      <div
                        className="absolute bottom-0 left-0 right-0 p-4 transition-all duration-500"
                        style={{
                          background:
                            theme === "dark"
                              ? `linear-gradient(to top, rgba(35, 35, 44, 0.95) 0%, rgba(35, 35, 44, 0.8) 70%, transparent 100%)`
                              : `linear-gradient(to top, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.8) 70%, transparent 100%)`,
                          backdropFilter: "blur(10px)",
                        }}
                      >
                        <h3
                          className="text-lg font-bold mb-1 group-hover:scale-105 transition-transform duration-300"
                          style={{ color: textColor }}
                        >
                          {proj.name}
                        </h3>
                        <div
                          className="h-1 rounded-full transition-all duration-500 group-hover:w-full"
                          style={{
                            backgroundColor: borderColor,
                            width: "30%",
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-20">
                <h3
                  className="text-2xl font-bold mb-3"
                  style={{ color: textColor }}
                >
                  No Projects Available
                </h3>
                <p className="text-lg opacity-70" style={{ color: textColor }}>
                  There are currently no projects to display
                </p>
              </div>
            )}
          </div>

          {isModalOpen && (
            <div
              className="
    fixed
    inset-0
    z-[9999]
    flex
    items-start
    justify-center
    overflow-y-auto
    overflow-x-hidden
    p-2
    md:p-4
  "
              onClick={closeModal}
              style={{
                backgroundColor: "rgba(0,0,0,0.55)",
                backdropFilter: "blur(6px)",
              }}
            >
              <div
                className="relative w-[98vw] md:w-[95vw] max-w-[1400px] max-h-[96vh]
min-h-fit
overflow-visible rounded-2xl overflow-hidden flex flex-col"
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: cardColor,
                  border: `2px solid ${borderColor}`,
                  boxShadow:
                    theme === "dark"
                      ? `0 30px 70px rgba(0,0,0,0.6)`
                      : `0 30px 70px rgba(0,0,0,0.25)`,
                }}
              >
                <div
                  className="px-6 py-4 flex items-center justify-between flex-wrap gap-3 sticky top-0 z-20"
                  style={{
                    borderBottom: `1px solid ${theme === "dark" ? "#ffffff18" : "#00000010"}`,
                    backgroundColor: cardColor,
                  }}
                >
                  <div>
                    <div
                      className="text-sm opacity-80"
                      style={{ color: textColor }}
                    >
                      Tower / Building
                    </div>
                    <div
                      className="text-2xl font-extrabold"
                      style={{ color: textColor }}
                    >
                      {activeTower?.name || `Tower ${activeTower?.id || ""}`}
                    </div>
                    <div
                      className="text-sm opacity-80 mt-1"
                      style={{ color: textColor }}
                    >
                      Project: {projectName || `Project ${projectId}`}
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <div
                      className="px-3 py-1 rounded-full text-xs font-bold"
                      style={{
                        backgroundColor:
                          theme === "dark" ? "#ffffff10" : "#00000008",
                        color: textColor,
                        border: `1px solid ${borderColor}55`,
                      }}
                      title="Role is taken from localStorage"
                    >
                      Role: {String(activeRoleId || "").toUpperCase()}
                    </div>

                    <button
                      type="button"
                      onClick={closeModal}
                      className="px-4 py-2 rounded-xl font-bold"
                      style={{
                        backgroundColor:
                          theme === "dark" ? "#ffffff10" : "#00000008",
                        color: textColor,
                        border: `1px solid ${borderColor}55`,
                      }}
                    >
                      ✕ Close
                    </button>
                  </div>
                  <div className="flex items-center gap-2 mt-4">
                    <button
                      type="button"
                      onClick={() => setActiveModalTab("checklists")}
                      className="px-3 md:px-4 py-2 rounded-xl text-xs md:text-sm font-bold flex-shrink-0 "
                      style={{
                        backgroundColor:
                          activeModalTab === "checklists"
                            ? borderColor
                            : theme === "dark"
                              ? "#ffffff10"
                              : "#00000008",
                        color:
                          activeModalTab === "checklists"
                            ? "#1b1b1b"
                            : textColor,
                        border: `1px solid ${borderColor}55`,
                      }}
                    >
                      📋 Checklists
                    </button>

                    <button
                      type="button"
                      onClick={() => setActiveModalTab("reports")}
                      className="px-3 md:px-4 py-2 rounded-xl text-xs md:text-sm font-bold flex-shrink-0 "
                      style={{
                        backgroundColor:
                          activeModalTab === "reports"
                            ? borderColor
                            : theme === "dark"
                              ? "#ffffff10"
                              : "#00000008",
                        color:
                          activeModalTab === "reports" ? "#1b1b1b" : textColor,
                        border: `1px solid ${borderColor}55`,
                      }}
                    >
                      📄 Reports
                    </button>
                  </div>
                </div>

                <div className="w-full px-2 md:px-4 lg:px-6 py-4 overflow-y-auto overflow-x-hidden flex-1 min-h-0">
                  {modalLoading ? (
                    <div className="py-10 text-center">
                      <div
                        className="text-lg font-bold"
                        style={{ color: textColor }}
                      >
                        Loading checklist details…
                      </div>
                    </div>
                  ) : modalError ? (
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        backgroundColor:
                          theme === "dark" ? "#ffffff0c" : "#00000006",
                        border: `1px solid ${borderColor}55`,
                        color: textColor,
                      }}
                    >
                      {modalError}
                    </div>
                  ) : (
                    <>
                      {Array.isArray(modalData?.stage_history) &&
                        modalData.stage_history.length > 0 && (
                          <div
                            className="p-4 rounded-2xl mb-5"
                            style={{
                              backgroundColor:
                                theme === "dark" ? "#ffffff0c" : "#00000006",
                              border: `1px solid ${borderColor}55`,
                            }}
                          >
                            <div
                              className="text-lg font-extrabold mb-2"
                              style={{ color: textColor }}
                            >
                              Current Stage History
                            </div>
                            {modalData.stage_history.slice(0, 3).map((sh) => (
                              <div
                                key={sh.id}
                                className="rounded-xl p-3 mb-2"
                                style={{
                                  backgroundColor:
                                    theme === "dark" ? "#ffffff08" : "#ffffff",
                                  border: `1px solid ${theme === "dark" ? "#ffffff10" : "#00000010"}`,
                                }}
                              >
                                <div
                                  className="flex flex-wrap gap-3 text-sm"
                                  style={{ color: textColor }}
                                >
                                  <span>
                                    <b>ID:</b> {sh.id}
                                  </span>
                                  <span>
                                    <b>Stage:</b> {sh.stage}
                                  </span>
                                  <span>
                                    <b>Phase:</b> {sh.phase_id}
                                  </span>
                                  <span>
                                    <b>Status:</b> {sh.status}
                                  </span>
                                  <span>
                                    <b>Started:</b> {fmtDateTime(sh.started_at)}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      {activeModalTab === "checklists" && (
                        <>
                          {!modalData ? (
                            <div
                              className="p-4 rounded-2xl"
                              style={{
                                backgroundColor:
                                  theme === "dark" ? "#ffffff0c" : "#00000006",
                                border: `1px solid ${borderColor}55`,
                                color: textColor,
                              }}
                            >
                              No checklist data found.
                            </div>
                          ) : (
                            <>
                              <div className="space-y-5">
                                {flattenChecklists(modalData).length === 0 ? (
                                  <div
                                    className="p-4 rounded-2xl"
                                    style={{
                                      backgroundColor:
                                        theme === "dark"
                                          ? "#ffffff0c"
                                          : "#00000006",
                                      border: `1px solid ${borderColor}55`,
                                      color: textColor,
                                    }}
                                  >
                                    No checklists found.
                                  </div>
                                ) : (
                                  flattenChecklists(modalData).map((cl) => {
                                    const checklistStarted =
                                      String(cl?.status || "").toLowerCase() !==
                                      "not_started";

                                    return (
                                      <div
                                        key={cl.id}
                                        className="rounded-2xl overflow-hidden w-full min-w-0"
                                        style={{
                                          backgroundColor:
                                            theme === "dark"
                                              ? "#ffffff08"
                                              : "#00000005",
                                          border: `1px solid ${
                                            theme === "dark"
                                              ? "#ffffff12"
                                              : "#00000010"
                                          }`,
                                        }}
                                      >
                                        {/* HEADER */}

                                        <div
                                          className="p-4 border-b"
                                          style={{
                                            borderColor:
                                              theme === "dark"
                                                ? "#ffffff12"
                                                : "#00000010",
                                          }}
                                        >
                                          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 min-w-0">
                                            <div>
                                              <div
                                                className="text-lg font-bold"
                                                style={{ color: textColor }}
                                              >
                                                {cl?.checklist_name ||
                                                  cl?.name ||
                                                  cl?.title ||
                                                  `Checklist ${cl?.id}`}
                                              </div>

                                              <div
                                                className="text-sm opacity-80 mt-1"
                                                style={{ color: textColor }}
                                              >
                                                Status: {cl?.status || "-"}
                                              </div>
                                            </div>

                                            {!checklistStarted && (
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  startChecklist(cl.id)
                                                }
                                                disabled={startingById[cl.id]}
                                                className="px-4 py-2 rounded-xl font-bold"
                                                style={{
                                                  backgroundColor: borderColor,
                                                  color: "#1b1b1b",
                                                }}
                                              >
                                                {startingById[cl.id]
                                                  ? "Starting..."
                                                  : "Start Checklist"}
                                              </button>
                                            )}
                                          </div>
                                        </div>

                                        {/* ITEMS */}

                                        <div className="p-4 space-y-4">
                                          {(cl?.items || []).map((item) => (
                                            <div
                                              key={item.id}
                                              className="rounded-xl p-3 md:p-4"
                                              style={{
                                                backgroundColor:
                                                  theme === "dark"
                                                    ? "#ffffff06"
                                                    : "#00000004",
                                              }}
                                            >
                                              <div
                                                className="font-semibold mb-2"
                                                style={{ color: textColor }}
                                              >
                                                {item?.title ||
                                                  item?.question ||
                                                  `Item ${item?.id}`}
                                              </div>

                                              <div
                                                className="text-sm opacity-80 mb-3"
                                                style={{ color: textColor }}
                                              >
                                                Status: {item?.status || "-"}
                                              </div>

                                              {/* REMARK */}

                                              <textarea
                                                rows={3}
                                                value={
                                                  remarkByItemId[item.id] || ""
                                                }
                                                onChange={(e) =>
                                                  setRemarkByItemId((p) => ({
                                                    ...p,
                                                    [item.id]: e.target.value,
                                                  }))
                                                }
                                                placeholder="Remarks..."
                                                className="w-full p-3 rounded-xl mb-3 resize-none"
                                                style={{
                                                  backgroundColor:
                                                    theme === "dark"
                                                      ? "#ffffff10"
                                                      : "#00000008",
                                                  color: textColor,
                                                  border: `1px solid ${borderColor}55`,
                                                }}
                                              />

                                              {/* FILES */}

                                              {activeRoleId === "maker" && (
                                                <input
                                                  type="file"
                                                  multiple
                                                  onChange={(e) => {
                                                    const files = Array.from(
                                                      e.target.files || [],
                                                    );

                                                    setMakerFilesByItemId(
                                                      (p) => ({
                                                        ...p,
                                                        [item.id]: files,
                                                      }),
                                                    );
                                                  }}
                                                  className="mb-3 block"
                                                />
                                              )}

                                              {/* OPTIONS */}

                                              {/* ACTIONS */}

                                              <div className="flex flex-wrap items-center gap-2">
                                                {/* CHECKER / SUPERVISOR ONLY */}
                                                {(activeRoleId === "checker" ||
                                                  activeRoleId ===
                                                    "supervisor") &&
                                                  (item?.options || []).map(
                                                    (op) => {
                                                      const verifyKey = `${item.id}:${op.id}:${activeRoleId}`;

                                                      return (
                                                        <button
                                                          key={op.id}
                                                          type="button"
                                                          disabled={
                                                            verifyingKey[
                                                              verifyKey
                                                            ]
                                                          }
                                                          onClick={() =>
                                                            verifyChecklistItem(
                                                              {
                                                                checklistItemId:
                                                                  item.id,
                                                                option: op,
                                                                item,
                                                              },
                                                            )
                                                          }
                                                          className="px-3 md:px-4 py-2 rounded-xl text-xs md:text-sm font-bold flex-shrink-0"
                                                          style={{
                                                            backgroundColor:
                                                              borderColor,
                                                            color: "#1b1b1b",
                                                          }}
                                                        >
                                                          {verifyingKey[
                                                            verifyKey
                                                          ]
                                                            ? "Please wait..."
                                                            : op?.name ||
                                                              "Option"}
                                                        </button>
                                                      );
                                                    },
                                                  )}

                                                {/* MAKER ONLY */}
                                                {activeRoleId === "maker" &&
                                                  makerCanSubmitItem(item) && (
                                                    <button
                                                      type="button"
                                                      onClick={() =>
                                                        submitMakerDone({
                                                          item,
                                                        })
                                                      }
                                                      disabled={
                                                        makerSubmittingByItemId[
                                                          item.id
                                                        ]
                                                      }
                                                      className="px-3 md:px-4 py-2 rounded-xl text-xs md:text-sm font-bold flex-shrink-0"
                                                      style={{
                                                        backgroundColor:
                                                          borderColor,
                                                        color: "#1b1b1b",
                                                      }}
                                                    >
                                                      {makerSubmittingByItemId[
                                                        item.id
                                                      ]
                                                        ? "Submitting..."
                                                        : "Submit"}
                                                    </button>
                                                  )}
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                      {activeModalTab === "reports" && (
                        <div
                          className="p-4 rounded-2xl"
                          style={{
                            backgroundColor:
                              theme === "dark" ? "#ffffff0c" : "#00000006",
                            border: `1px solid ${borderColor}55`,
                          }}
                        >
                          {/* HEADER */}

                          <div className="flex items-center justify-between mb-5">
                            <div
                              className="text-xl font-extrabold"
                              style={{ color: textColor }}
                            >
                              Tower Report
                            </div>

                            <button
                              type="button"
                              onClick={downloadTowerPdfReport}
                              className="px-4 py-2 rounded-xl font-bold"
                              style={{
                                backgroundColor: borderColor,
                                color: "#1b1b1b",
                              }}
                            >
                              📥 Download Report
                            </button>
                          </div>

                          {/* FILTERS */}

                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
                            {/* CHECKLIST */}

                            <select
                              value={towerReportFilters.checklistId || ""}
                              onChange={(e) =>
                                setTowerReportFilters((p) => ({
                                  ...p,
                                  checklistId: e.target.value,
                                }))
                              }
                              className="px-3 py-2 rounded-xl"
                            >
                              <option value="">All Checklists</option>

                              {(towerReportData?.checklists || []).map((cl) => (
                                <option key={cl.id} value={cl.id}>
                                  {cl.checklist_name ||
                                    cl.name ||
                                    cl.title ||
                                    `Checklist ${cl.id}`}
                                </option>
                              ))}
                            </select>

                            {/* STAGE */}

                            <select
                              value={towerReportFilters.stageId}
                              onChange={(e) =>
                                setTowerReportFilters((p) => ({
                                  ...p,
                                  stageId: e.target.value,
                                }))
                              }
                              className="px-3 py-2 rounded-xl"
                            >
                              <option value="">All Stages</option>

                              {stageOptions.map((st) => (
                                <option
                                  key={st.stage_id || st.id}
                                  value={st.stage_id || st.id}
                                >
                                  {st.stage_name || st.name}
                                </option>
                              ))}
                            </select>

                            {/* STATUS */}

                            <select
                              value={towerReportFilters.status}
                              onChange={(e) =>
                                setTowerReportFilters((p) => ({
                                  ...p,
                                  status: e.target.value,
                                }))
                              }
                              className="px-3 py-2 rounded-xl"
                            >
                              <option value="">All Status</option>

                              <option value="completed">Completed</option>

                              <option value="in_progress">In Progress</option>

                              <option value="not_started">Not Started</option>
                            </select>
                          </div>

                          {/* APPLY FILTER */}

                          <button
                            type="button"
                            onClick={fetchTowerReport}
                            className="px-4 py-2 rounded-xl font-bold mb-5"
                            style={{
                              backgroundColor: borderColor,
                              color: "#1b1b1b",
                            }}
                          >
                            Apply Filters
                          </button>

                          {/* REPORT CONTENT */}

                          {towerReportLoading ? (
                            <div style={{ color: textColor }}>
                              Loading report...
                            </div>
                          ) : towerReportError ? (
                            <div style={{ color: textColor }}>
                              {towerReportError}
                            </div>
                          ) : Array.isArray(towerReportData?.checklists) ? (
                            <div className="space-y-4">
                              {towerReportData.checklists.map((report) => (
                                <div
                                  key={report.id}
                                  className="rounded-2xl p-4"
                                  style={{
                                    backgroundColor:
                                      theme === "dark"
                                        ? "#ffffff08"
                                        : "#ffffff",
                                    border: `1px solid ${
                                      theme === "dark"
                                        ? "#ffffff10"
                                        : "#00000010"
                                    }`,
                                  }}
                                >
                                  <div
                                    className="text-lg font-bold"
                                    style={{ color: textColor }}
                                  >
                                    {report.checklist_name ||
                                      report.name ||
                                      `Checklist ${report.id}`}
                                  </div>

                                  <div
                                    className="text-sm mt-2"
                                    style={{ color: textColor }}
                                  >
                                    Status: {report.status}
                                  </div>

                                  <div
                                    className="text-sm"
                                    style={{ color: textColor }}
                                  >
                                    Current Role: {report.current_role}
                                  </div>

                                  <div
                                    className="text-sm"
                                    style={{ color: textColor }}
                                  >
                                    Started: {fmtDateTime(report.started_at)}
                                  </div>

                                  <div
                                    className="text-sm"
                                    style={{ color: textColor }}
                                  >
                                    Completed:{" "}
                                    {fmtDateTime(report.completed_at)}
                                  </div>

                                  {Array.isArray(
                                    report.items || report.questions,
                                  ) &&
                                    report.items.length > 0 && (
                                      <div className="mt-4 space-y-2">
                                        {(report.items || report.questions).map(
                                          (item) => (
                                            <div
                                              key={item.id}
                                              className="rounded-xl p-3"
                                              style={{
                                                backgroundColor:
                                                  theme === "dark"
                                                    ? "#ffffff06"
                                                    : "#00000005",
                                              }}
                                            >
                                              <div
                                                className="font-semibold"
                                                style={{ color: textColor }}
                                              >
                                                {item.title}
                                              </div>

                                              <div
                                                className="text-sm mt-1"
                                                style={{ color: textColor }}
                                              >
                                                Status: {item.status}
                                              </div>

                                              {item.maker_remark && (
                                                <div
                                                  className="text-sm mt-1"
                                                  style={{ color: textColor }}
                                                >
                                                  Maker: {item.maker_remark}
                                                </div>
                                              )}

                                              {item.check_remark && (
                                                <div
                                                  className="text-sm mt-1"
                                                  style={{ color: textColor }}
                                                >
                                                  Checker: {item.check_remark}
                                                </div>
                                              )}
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{ color: textColor }}>
                              No reports found.
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div
                  className="px-6 py-4 flex items-center justify-end gap-3"
                  style={{
                    borderTop: `1px solid ${theme === "dark" ? "#ffffff18" : "#00000010"}`,
                  }}
                >
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-5 py-2 rounded-xl font-bold"
                    style={{
                      backgroundColor:
                        theme === "dark" ? "#ffffff10" : "#00000008",
                      color: textColor,
                      border: `1px solid ${borderColor}55`,
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsPage;
